import Backbone from 'backbone'
import template from './date-selector.hbs'
import DateInput from 'scoreboard/components/date-input'
import _ from 'lodash'
import select from 'scoreboard-select'

/**
 * Used for specifying an initiative note is for all time or for a particular
 * date.
 */
var DateSelector = Backbone.View.extend({

	tagName: 'form',

	events: {
		'change .type': '_changeType',
		'submit': 'submit'
	},

	initialize: function(options) {
		this.appliesTo = options && options.appliesTo
	},

	render: function() {
		this.$el.empty().append(template())

		this.dateInput = new DateInput({
			el: this.$('.date'),
			initialValue: this.appliesTo
		}).render()

		if (this.appliesTo) {
			this.$('.type').val('specific-date')
		}
		this._changeType()

		select(this.el.querySelectorAll('select'))

		return this
	},

	_changeType: function() {
		var type = this.$('select.type').val()
		this.$('.date-label').toggleClass('is-not-displayed', type !== 'specific-date')
	},

	submit: function(e) {
		e.preventDefault()

		var type = this.$('select.type').val()
		var date = type === 'all-time' ? null : this.dateInput.getIsoDate()
		this.trigger('change:date', date)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.dateInput], 'remove')
	}

})

export default DateSelector

DateSelector.__filename__ = 'notes/date-selector.js'
